var _circle, _path, _ellipse, _path2, _circle2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcAvatarChat = function SvgIcAvatarChat(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#38C5F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5066 23.062C20.1734 22.7858 23.0626 19.7231 23.0626 15.9856C23.0626 12.0662 19.8853 8.88885 15.9659 8.88885C12.0465 8.88885 8.86914 12.0662 8.86914 15.9856C8.86914 16.899 9.04169 17.772 9.35597 18.574",
    stroke: "white",
    strokeWidth: 0.677249,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.9671,
    cy: 15.9857,
    rx: 4.93391,
    ry: 4.93391,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.168 21.9334L12.317 18.4188L14.8853 19.8382L11.168 21.9334Z",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.8302,
    cy: 23.0148,
    r: 1.01382,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.40347 13.2794C8.09332 13.5613 7.11133 14.7263 7.11133 16.1207C7.11133 17.5608 8.1587 18.7562 9.53324 18.9868C9.10723 18.0752 8.86926 17.0582 8.86926 15.9856C8.86926 15.0273 9.0592 14.1134 9.40347 13.2794Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5179 13.2797C23.8273 13.5621 24.8086 14.7268 24.8086 16.1207C24.8086 17.5602 23.7619 18.7553 22.3881 18.9865C22.8141 18.075 23.052 17.0581 23.052 15.9856C23.052 15.0274 22.8621 14.1136 22.5179 13.2797Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcAvatarChat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_avatar_chat.88feed99.svg";
export { ForwardRef as ReactComponent };